import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const TableContainer = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  border-radius: 5px;
  padding: 10px;
  min-height: 175px;
  margin: 20px 0px;
`;
export const AuthorityPairTable = styled.div`
  display: grid;
  border-collapse: collapse;
  min-width: 100%;
  grid-template-columns: ${({ outbound }) =>
    outbound ? '3fr 3fr 2fr 0.5fr;' : '4fr 4fr 0.5fr;'};
  align-items: center;
`;
export const AuthorityPairTBody = styled.div`
  display: contents;
`;

export const AuthorityPairTHead = styled.div`
  display: contents;
`;

export const AuthorityPairTRow = styled.div`
  display: contents;
`;

export const AuthorityPairTData = styled(Box).attrs(({ flexEnd }) => ({
  horizontal: true,
  width: '100%',
  height: '100%',
  justify: flexEnd ? 'flex-end' : 'flex-start',
  p: '5px',
  bg: 'background',
  color: 'primaryText',
  align: 'center',
}))`
  overflow: ${({ overflow }) => (overflow ? 'hidden' : 'inherit')};
  text-overflow: ${({ overflow }) => (overflow ? 'ellipsis' : 'inherit')};
  white-space: ${({ overflow }) => (overflow ? 'nowrap' : 'inherit')};
`;
export const AuthorityPairTH = styled.div`
  padding: 10px 5px;
  font-size: 12px;
  font-weight: bold;
  text-align: left;
  color: ${({ theme }) => theme.colors.secondaryText};
`;
